import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { filter } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { AppSettings } from '../../PRE-LOAD/app-settings';

@Injectable()
export class AppInsightsMonitoringService {
    appInsights: ApplicationInsights;
    constructor(private router: Router, private appSettings: AppSettings) {
        this.appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: environment.appInsights.instrumentationKey,
                enableAutoRouteTracking: false // option to log all route changes
            }
        });
        this.appInsights.loadAppInsights();
        this.loadCustomTelemetryProperties()
        this.createRouterSubscription();

        this.userId  = this.appInsights.context.user.id;
        this.sessionId = this.appInsights.context.getSessionId();

        console.log(`Application Insights data - please send the UserId and SessionId to one of the developer team to debug your session -- userId: ${this.userId} `)

    }

    userId: string;
    sessionId: string;


    logPageView(name?: string, url?: string) { // option to call manually
        this.appInsights.trackPageView({
            name: name,
            uri: url
        });
    }

    logEvent(name: string, properties?: { [key: string]: any }) {
        this.appInsights.trackEvent({ name: name }, properties);
    }

    logMetric(name: string, average: number, properties?: { [key: string]: any }) {
        this.appInsights.trackMetric({ name: name, average: average }, properties);
    }

    logException(exception: Error, severityLevel?: number) {
        this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
    }

    logTrace(message: string, properties?: { [key: string]: any }) {
        this.appInsights.trackTrace({ message: message }, properties);
    }


    private loadCustomTelemetryProperties() {
        this.appInsights.addTelemetryInitializer(envelope => {
            var item = envelope.baseData;
            item.properties = item.properties || {};
            item.properties["externalReferenceId"] = this.appSettings.externalReferenceId;
        });

    }

    private createRouterSubscription() {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            if(this.appInsights.context.getSessionId() != null){
                console.log(`Application Insights data -- please send this message to one of the developer team to debug your session - userId: ${this.userId}, sessionId: ${this.appInsights.context.getSessionId()}`)
            }
            this.logPageView(null, event.urlAfterRedirects);
        });
    }

}